import {getAppState} from "../helpers/tools";
import Worker from "worker-loader!../workers/summary.worker.js";

/**
 *
 * @returns {Function}
 */
export const goTo = (slide) => {
  return dispatch => {
    dispatch({type: "GO_TO", data: slide});
  }
};

/**
 *
 * @returns {Function}
 */
export const goBack = () => {
  return dispatch => {
    dispatch({type: "GO_BACK"});
  }
};

/**
 *
 * @returns {Function}
 */
export const reset = () => {
  return dispatch => {
    dispatch({type: "RESET"});
  }
};

/**
 *
 * @returns {Function}
 */
export const fetchSummary = () => {
  return (dispatch, getState) => {
    const state = getAppState( getState() );
    const worker = new Worker();
    worker.postMessage([state]);
    worker.addEventListener('message', event => {
      dispatch({type: "FETCH_SUMMARY", data: event.data});
    });
  }
};
